import axios from 'axios';

import config from '../utils/config';
import store from '../store/store';
import * as CommentsActions from '../actions/comments';
import * as AuthCreators from './auth';
import getUserId from '../selectors/getUserId';

const URL = config().comments;

axios.defaults.xsrfHeaderName = 'X-CSRFTOKEN';
axios.defaults.xsrfCookieName = 'csrftoken';

export const comments = (): any => {
  return (dispatch): void => {
    dispatch(CommentsActions.fetchCommentsPending());
    const params = new URLSearchParams();

    function paramsAppender (paramName, paramVal) {
      if (paramVal) {
        return params.append(paramName, paramVal);
      } else {
        return null;
      }
    }
    paramsAppender('customer_id', getUserId(store.getState()));

    axios({
      method: 'get',
      url: `${URL}/?${params}`,
    })
      .then(response => {
        dispatch(CommentsActions.fetchCommentsSuccess(response.data));
      })
      .catch(error => {
        if (error.response.status === 401) {
          dispatch(AuthCreators.fetchRefreshAuthToken(comments));
        } else {
          dispatch(CommentsActions.fetchCommentsFail());
        }
      });
  };
};

const URL2 = config().sendComment;

export const sendComment = (): any => {
  return (dispatch): void => {
    dispatch(CommentsActions.fetchSendCommentsPending());
    const params = new URLSearchParams();

    function paramsAppender (paramName, paramVal) {
      if (paramVal) {
        return params.append(paramName, paramVal);
      } else {
        return null;
      }
    }

    paramsAppender('customer_id', getUserId(store.getState()));
    paramsAppender('comment', store.getState().comments.textAreaValue.toString());

    axios({
      method: 'post',
      url: URL2,
      data: params,
    })
      .then(response => {
        dispatch(CommentsActions.fetchSendCommentsSuccess(response.data));
        setTimeout(() => {
          return dispatch(comments());
        }, 1000);
      })
      .catch(error => {
        if (error.response.status === 401) {
          dispatch(AuthCreators.fetchRefreshAuthToken(sendComment));
        } else {
          dispatch(CommentsActions.fetchSendCommentsFail());
        }
      });
  };
};
